var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getThemeObject && _vm.theme && _vm.theme !== 'Null')?_c('icon-moon',{class:`icon-theme icon-theme--${_vm.getThemeObject.color}`,attrs:{"name":_vm.getThemeObject.slug,"size":_vm.size}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }